import React, { useContext, useState, useEffect } from "react";
import { store } from "../store";
import { Row, Col } from 'antd';
import { Text, View, FlatList, Pressable, ScrollView, TextInput } from 'react-native-web';
import { themeColor } from "../config/servervar";
import { ViewList, ViewDetail } from '../component/listdetail';
import axios from 'axios';
import { server_var } from "../config/servervar";

const LIST_DEFINE = [
  { id: 1, field1: 'id', flex: 0.05, textAlign: 'left', headerTitle: 'ID' },
  { id: 2, field1: 'mobileNumber', flex: 0.25, textAlign: 'left', headerTitle: 'เบอร์มือถือ' },
  { id: 3, field1: 'displayName', flex: 0.45, textAlign: 'left', headerTitle: 'ผู้ใช้งาน' },
  { id: 4, field1: 'memberStatus', flex: 0.15, textAlign: 'left', headerTitle: 'Status' },
];

const DETAIL_DEFINE = [
  {
    id: 1, fieldName: 'id', displayName: 'ID', newValue: 0, controlOption: {
      textInputStyle: { backgroundColor: 'lightgray' }, textInputProp: { editable: false }
    }
  },
  { id: 2, fieldName: 'avatar', displayName: 'รูป', newValue: '', controlType: 'photoupload', controlOption: { width: 80, height: 80 } },
  { id: 3, fieldName: 'mobileNumber', displayName: 'เบอร์มือถือ', newValue: '' },
  { id: 4, fieldName: 'firstName', displayName: 'ชื่อ', newValue: '' },
  { id: 5, fieldName: 'lastName', displayName: 'นามสกุล', newValue: '' },
  {
    id: 6, fieldName: 'gender', displayName: 'เพศ', newValue: 'F', controlType: 'radio',
    controlOption: {
      list: [
        { id: 1, title: 'หญิง', value: 'F' },
        { id: 2, title: 'ชาย', value: 'M' },
      ]
    }
  },
  { id: 12, fieldName: 'birthDay', displayName: 'วันเกิด', newValue: '' },
  { id: 13, fieldName: 'birthMonth', displayName: 'เดือนเกิด', newValue: '' },
  { id: 14, fieldName: 'birthYear', displayName: 'ปีเกิด', newValue: '' },
  {
    id: 15, fieldName: 'memberStatus', displayName: 'สถานะ', newValue: '', controlType: 'dropdown', controlOption: {
      list: [
        { id: 1, title: 'verified', value: 'verified' }, { id: 2, title: 'todelete', value: 'todelete' }
      ]
    }
  },
  {
    id: 16, fieldName: 'userReqDeleteDate', displayName: 'วันที่แจ้งลบ', newValue: '', controlType: 'dateinput',
    controlOption: {
      visible: 'code04'
    }
  },
  { id: 17, fieldName: 'refCode', displayName: 'refCode', newValue: '' },
];

const QUERY_NAME = 'users';
const QUERY_CON = { staffFlag: 0 };
const NEW_VALUE = { staffFlag: 0 };
// const QUERY_CON = {  };

export const Customer = () => {
  const [selectIndex, setSelectIndex] = useState(-1);
  const [queryParams, setQueryParams] = useState();
  const beforeSavePress = async (data) => {
    return { data, errorList: validateData(data) }
  }

  const validateData = (data) => {
    let tmpErrorList = [];
    for (const item of ['mobileNumber', 'firstName', 'lastName']) {
      if (!(data?.[item])) {
        tmpErrorList = [...tmpErrorList, { fieldName: item, errorFlag: true, errorMsg: 'ไม่สามารถเว้นไว้ได้' }]
      }
    }
    return tmpErrorList
  }

  const downloadTxtFile = async () => {
    const res = await axios.post(`${server_var.server_api}/extractCustomer`, queryParams)
    if (res?.data?.csv) {
      console.log('texts', res.data.csv);
      const file = new Blob([res.data.csv], { type: 'text/plain' });
      const element = document.createElement("a");
      element.href = URL.createObjectURL(file);
      element.download = "customer" + Date.now() + ".csv";
      document.body.appendChild(element);
      element.click();
    } else if (res.data.message) {
      alert(res.data.message);
    } else {
      alert('มีข้อผิดพลาดเกิดขึ้น')
    }
  }

  const onChangeQuery = (queryParams) => {
    setQueryParams(queryParams);
  }

  return (
    <Row style={{ flex: 1, flexWrap: 'nowrap' }}>
      <Col span={12} style={{ height: '100vh', padding: 5 }}>
        <ViewList
          onPress={id => setSelectIndex(id)} listDefine={LIST_DEFINE} queryName={QUERY_NAME} queryCon={QUERY_CON}
          onChangeQuery={onChangeQuery}
          viewListOption={{
            hideNew: true, topControlList: [
              { id: 1, title: 'Search', type: 'multi_column_search', searchField: ['firstName', 'lastName', 'mobileNumber'] },
              {
                id: 3, title: '', type: 'dropdown', searchField: 'memberStatus', list: [
                  { id: 1, title: 'verified', value: 'verified' },
                  { id: 2, title: 'todelete', value: 'todelete' },
                ]
              },
              { id: 5, title: 'Export', type: 'button', onPress: () => downloadTxtFile() },
            ]
          }}
        />
      </Col>
      <Col span={12} style={{
        height: '100vh', padding: 5,
        borderWidth: 1, borderLeftStyle: 'solid', borderColor: 'gray'
      }}>
        <ViewDetail
          selectIndex={selectIndex} detailDefine={DETAIL_DEFINE} queryName={QUERY_NAME} onSavePress={(id) => setSelectIndex(-1)}
          newValue={NEW_VALUE}
          beforeSavePress={beforeSavePress}
        />
      </Col>
    </Row>
  )
}

